<div class="row">
  <div class="col-12 col-md">
    <ng-content />
  </div>
  @let buildingValue = building();
  @let buildingLabelValue = buildingLabel();
  @let currentLabelValue = currentLabel();
  @if (!isLoading() && !hasError() && buildingValue && buildingLabelValue) {
    <div class="col-12 col-md-auto mt-2 pb-3 mb-4" data-test="labelImprovement">
      <!-- Label Improvement -->
      @if (buildingValue.objectType !== ObjectTypeDTO.PARKING) {
        <div>
          <div class="row">
            <div class="col-12 col-sm-auto pe-0 label-improvement-text text-center text-sm-end">
              <strong>{{ 'effectOnEnergyLabel' | translate }}</strong>
              @if (buildingLabelValue.currentLabel.registrationDate) {
                <div class="small">
                  {{ 'registeredEnergyLabelToNewLabel' | translate }}
                </div>
              }
              @if (!buildingLabelValue.currentLabel.registrationDate) {
                <div class="small">
                  {{ 'calculatedEnergyLabelToNewLabel' | translate }}
                </div>
              }
            </div>
            <div class="col-auto ms-auto ms-sm-0 pe-0 mt-2 mt-sm-0">
              <cfp-energy-label [energyLabel]="currentLabelValue" data-test="energyLabelCurrent" />
            </div>
            <div class="col-auto mt-2 mt-sm-0">
              <div class="label-improvement-circle">
                <i class="fas fa-caret-right" aria-hidden="true"></i>
              </div>
            </div>
            <div class="col-auto me-auto me-sm-0 ps-0 mt-2 mt-sm-0">
              <cfp-energy-label [energyLabel]="improvedLabel()" data-test="energyLabelImproved" />
            </div>
          </div>
        </div>
      }
      <!-- Parking -->
      @if (
        buildingValue.objectType === ObjectTypeDTO.PARKING && (!currentLabelValue || currentLabelValue.label === '?')
      ) {
        <div class="text-center">
          <cfp-energy-label class="d-inline-block" [energyLabel]="{ label: 'parking' }" />
        </div>
      }
    </div>
    <!-- Label Improvement Alert -->
    @if (
      buildingValue.address &&
      !buildingValue.address.monument &&
      buildingValue.objectType !== ObjectTypeDTO.PARKING &&
      ((!buildingLabelValue.currentLabel.registrationDate && currentLabelValue?.indexType !== 'EPC') ||
        buildingLabelValue.currentLabel.registrationDate ||
        buildingLabelValue.labelSituationType === EnergyLabelSituationTypeDTO.CALCULATEDLABELISBETTERTHANREGISTERED)
    ) {
      <div class="col-12">
        <cfp-alert [alertStyle]="'primary'" [icon]="isExpired() ? 'exclamation-circle' : 'info-circle'">
          @if (!buildingLabelValue.currentLabel.registrationDate && currentLabelValue?.indexType !== 'EPC') {
            <small>
              {{ 'energylabelrvo' | translate }}
              @if ('energylabel.improvement.register.text' | translate) {
                <cfp-translated-router-link
                  class="d-print-none"
                  (linkClick)="showContactModal()"
                  [text]="'energylabel.improvement.register.text'"
                />
              }
              <div class="d-none d-print-block mt-3 fw-bold">
                <a href="mailto: info@cfp.nl"><i class="fa fa-envelope me-2"></i>info&#64;cfp.nl</a>
                <a href="https://www.cfp.nl" class="ms-4"><i class="fa fa-globe me-2"></i>www.cfp.nl</a>
              </div>
            </small>
          }
          @if (buildingLabelValue.currentLabel.registrationDate) {
            <small class="d-print-none">
              @if (isExpired()) {
                <span
                  >{{
                    'energy.label.expired'
                      | translate: { labelGroupRating: 'labelGroup.rating.' + labelGroup() | translate }
                  }}.</span
                >
              }
              {{
                'improved.label.info.certified.' + labelGroup()
                  | translate
                    : {
                        label: buildingLabelValue.currentLabel.label,
                        date: buildingLabelValue.currentLabel.validUntil | date: 'longDate'
                      }
              }}
            </small>
          }
          @if (
            buildingLabelValue.labelSituationType === EnergyLabelSituationTypeDTO.CALCULATEDLABELISBETTERTHANREGISTERED
          ) {
            <small class="d-print-none">
              <hr class="d-block" />
              <div class="row">
                <div class="col-auto">
                  <cfp-energy-label [energyLabel]="buildingLabelValue.currentLabel" />
                </div>
                <div class="col">
                  {{
                    'improved.label.calculatedLabelHigher'
                      | translate
                        : {
                            registeredLabel: buildingLabelValue.currentLabel.label,
                            calculatedLabel: currentLabelValue?.label
                          }
                  }}
                  @if (buildingLabelValue.currentLabel.indexType !== 'EPC') {
                    <div>
                      <button type="button" (click)="showContactModal()" class="btn btn-primary mt-3">
                        {{ 'energylabel.improvement.register' | translate }}
                      </button>
                    </div>
                  }
                </div>
              </div>
            </small>
          }
        </cfp-alert>
      </div>
    }
  }
</div>
